export default __webpack_public_path__ + "static/media/leveldb.200811d0.svg";